import makeRequest from 'utils/makeRequest'
import { ENDPOINTS } from 'config/apiEndpoints'
import ISliderResponse from 'models/Home/ISlider'
import ISocialMediaResponse from 'models/Common/ISocialMedia'

export const homeService = {
  getSlider: async (): Promise<ISliderResponse> => {
    try {
      const response: ISliderResponse = await makeRequest(
        'GET',
        ENDPOINTS.Home.GetSlider
      )

      return response
    } catch (error) {
      throw new Error(`Get slider data failed: ${error}`)
    }
  },
  getSocialMedia: async (): Promise<ISocialMediaResponse> => {
    try {
      const response: ISocialMediaResponse = await makeRequest(
        'GET',
        ENDPOINTS.Home.GetSocialMedia
      )

      return response
    } catch (error) {
      throw new Error(`Get social media data failed: ${error}`)
    }
  },
}
